import React, { forwardRef } from 'react';
import { referralProgramReferrerLanding } from 'reactApp/appHelpers/featuresHelpers/features/referralProgram';
import { isBaseSubscription } from 'reactApp/modules/billingData/billingData.types';
import type { IPropsWithPopup } from 'reactApp/modules/popup/popup.helpers';
import { renderSubscriptionInfoModal } from 'reactApp/ui/Mobile/SubscriptionInfoModal/SubscriptionInfoModal.helpers';

import { useSendAnalyticsAfterOpen } from '../hooks/useSendAnalyticsAfterOpen';
import type { Subscription, SubscriptionList } from '../SubscriptionsModal.types';
import { BaseSubscriptionItemComponent } from './Components/BaseSubscriptionItem/BaseSubscriptionItem';
import { ModernSubscriptionItemComponent } from './Components/ModernSubscriptionItem/ModernSubscriptionListItemComponent';
import { ReferralSubscriptionItem } from './Components/ReferralSubscriptionItem/ReferralSubscriptionItem';
import styles from './SubscriptionListComponent.css';

type Props = IPropsWithPopup<{ subscriptionList: SubscriptionList; isRebranding?: boolean; isRebrandingQuotaLanding?: boolean }>;

export const SubscriptionListComponent = forwardRef<HTMLDivElement, Props>(
    ({ subscriptionList, onClose, isRebranding = false, isRebrandingQuotaLanding }, ref) => {
        useSendAnalyticsAfterOpen(subscriptionList);

        const handleClick = (subscription: Subscription) => {
            onClose();
            renderSubscriptionInfoModal({ subscription, isRebrandingQuotaLanding, isRebranding });
        };

        return (
            <div className={styles.root} ref={ref}>
                {/* tempexp_18086-start */}
                {referralProgramReferrerLanding ? <ReferralSubscriptionItem isRebrandingQuotaLanding={isRebrandingQuotaLanding} /> : null}
                {/* tempexp_18086-end */}
                {subscriptionList.map((subscription) =>
                    isBaseSubscription(subscription) ? (
                        <BaseSubscriptionItemComponent
                            key={subscription.id}
                            subscription={subscription}
                            onClick={() => handleClick(subscription)}
                            isRebranding={isRebranding}
                            isRebrandingQuotaLanding={isRebrandingQuotaLanding}
                        />
                    ) : (
                        <ModernSubscriptionItemComponent
                            key={subscription.id}
                            subscription={subscription}
                            onClick={() => handleClick(subscription)}
                            isRebranding={isRebranding}
                            isRebrandingQuotaLanding={isRebrandingQuotaLanding}
                        />
                    )
                )}
            </div>
        );
    }
);

SubscriptionListComponent.displayName = 'SubscriptionListComponent';
